import React, { useContext } from "react";
import { UserContext } from "../../context/UserContext";

const UserBadge = () => {
  const { user } = useContext(UserContext);

  // Se l'utente ha firstName e lastName li combina, altrimenti usa username o "User" di default
  const fullName =
    user && user.firstName && user.lastName
      ? `${user.firstName} ${user.lastName}`
      : user?.username || "User";

  const info = user ? `${fullName} - ${user.role} • ${user.worksite}` : "User";

  return (
    <span className="font-medium bg-primary text-white border border-secondary p-2 rounded-full px-6">
      {info}
    </span>
  );
};

export default UserBadge;
